// @ts-nocheck
import { AITaskType } from '@/hooks/useAI';

export const promptTemplates: Record<AITaskType, string[]> = {
  case_analysis: [
    "Analise os pontos críticos deste processo",
    "Quais são os próximos passos recomendados?",
    "Identifique riscos e oportunidades neste caso",
    "Sugira uma estratégia processual para este caso"
  ],
  document_generation: [
    "Gere uma petição inicial baseada nestas informações",
    "Redija um contrato com as seguintes cláusulas",
    "Elabore uma defesa para este processo",
    "Crie um parecer jurídico sobre esta questão"
  ],
  deadline_management: [
    "Calcule os prazos processuais para este caso",
    "Identifique prazos urgentes que precisam de atenção",
    "Crie um cronograma de prazos para este processo",
    "Alerte sobre prazos que estão vencendo"
  ],
  legal_research: [
    "Pesquise jurisprudência sobre este tema",
    "Encontre precedentes relevantes para este caso",
    "Analise a legislação aplicável a esta situação",
    "Busque doutrinas sobre este assunto jurídico"
  ],
  general: [
    "Como posso ajudar com este processo?",
    "Explique este conceito jurídico",
    "Dê sugestões para melhorar a gestão do escritório",
    "Analise este documento jurídico"
  ]
};
